import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: unknown
  }
}

const PIXEL_ID = '2316644058832728'

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq = function (...args: unknown[]) {
    if (
      (fbq as unknown as { callMethod?: (...a: unknown[]) => void }).callMethod
    ) {
      ;(fbq as unknown as { callMethod: (...a: unknown[]) => void }).callMethod(
        ...args,
      )
    } else {
      ;(fbq as unknown as { queue: unknown[] }).queue.push(args)
    }
  } as Window['fbq'] & {
    queue: unknown[]
    loaded: boolean
    version: string
    push: typeof Array.prototype.push
  }

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  window._fbq = fbq

  // Load the Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Initialize pixel
  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(value?: number, currency = 'USD') {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      value: value || 6.39,
      currency,
      content_name: 'The Calm Home Reset',
      content_type: 'product',
    })
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel()
    trackPageView()
  }, [])

  return { trackAddToCart, trackPageView }
}
